import React, { useEffect, useState } from 'react';
import { X, MessageCircle } from 'lucide-react';
import { submitEnquiry } from './site/api';
import { waLink } from './site/brand';
import './site/lead-popup.css';
import HoneyPot from './site/HoneyPot';

const KEY = 'vkLeadPopupClosed';

// Small, non-blocking "plan my trip" card. Shows once per visit after 15s,
// never covers the header, and closes with ✕, "No thanks" or the Esc key.
const CustomizePackagePopup = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: '', phone: '', destination: '' });
  const [state, setState] = useState({ busy: false, ok: false, err: '' });

  useEffect(() => {
    let seen = false;
    try { seen = !!sessionStorage.getItem(KEY); } catch { /* storage blocked */ }
    if (seen) return undefined;
    const t = setTimeout(() => setOpen(true), 15000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const close = () => {
    setOpen(false);
    try { sessionStorage.setItem(KEY, '1'); } catch { /* storage blocked */ }
  };

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, ok: false, err: '' });
    try {
      await submitEnquiry({
        name: f.name.trim(), phone: f.phone.trim(), email: '',
        destination: f.destination.trim(), packageTitle: 'Website popup: plan my trip', productType: 'custom_package',
      });
      setState({ busy: false, ok: true, err: '' });
      setTimeout(close, 3500);
    } catch {
      setState({ busy: false, ok: false, err: 'Couldn’t send. Please WhatsApp us instead.' });
    }
  };

  if (!open) return null;

  return (
    <div className="vk-lead" role="dialog" aria-modal="false" aria-labelledby="vk-lead-title">
      <button type="button" className="vk-lead__x" onClick={close} aria-label="Close">
        <X size={18} />
      </button>
      {state.ok ? (
        <div className="vk-lead__done">
          <p id="vk-lead-title" className="vk-lead__title">Thank you!</p>
          <p className="vk-lead__sub">We’ll call you shortly with trip ideas.</p>
        </div>
      ) : (
        <>
          <p id="vk-lead-title" className="vk-lead__title">Planning a trip?</p>
          <p className="vk-lead__sub">Leave your number — we’ll call with the best options.</p>
          <form className="vk-lead__form" onSubmit={submit}><HoneyPot />
            <input required placeholder="Your name" value={f.name} onChange={set('name')} autoComplete="name" aria-label="Your name" />
            <input required type="tel" placeholder="Phone number" value={f.phone} onChange={set('phone')} autoComplete="tel" aria-label="Phone number" />
            <input placeholder="Where to? (optional)" value={f.destination} onChange={set('destination')} aria-label="Destination" />
            {state.err ? <p className="vk-lead__err" role="alert">{state.err}</p> : null}
            <button type="submit" className="vk-lead__go" disabled={state.busy}>{state.busy ? 'Sending…' : 'Call me back'}</button>
          </form>
          <div className="vk-lead__foot">
            <a href={waLink('Hi VK Tours, I want to plan a trip.')} target="_blank" rel="noopener noreferrer"><MessageCircle size={15} /> WhatsApp</a>
            <button type="button" onClick={close}>No thanks</button>
          </div>
        </>
      )}
    </div>
  );
};

export default CustomizePackagePopup;
